import { render, staticRenderFns } from "./region-floor-loading.vue?vue&type=template&id=b0d57cd6&scoped=true"
import script from "./region-floor-loading.vue?vue&type=script&lang=js"
export * from "./region-floor-loading.vue?vue&type=script&lang=js"
import style0 from "./region-floor-loading.vue?vue&type=style&index=0&id=b0d57cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d57cd6",
  null
  
)

export default component.exports